module.exports = __webpack_public_path__ + "img/dashboard_white.124ec14f.svg";